<div
  [class]="compact
    ? 'mb-0 mt-0 w-full min-w-0 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm'
    : 'mb-2 mt-1.5 w-full min-w-0 overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm'"
  [formGroup]="form"
>

  <div
    [class]="compact
      ? 'flex min-w-0 items-center border-b border-gray-100 px-3 py-2'
      : 'flex min-w-0 items-center border-b border-gray-100 px-3 py-2'"
  >
    <span class="min-w-0 flex-1 truncate text-xs font-semibold uppercase tracking-wide text-gray-500">
      {{ 'new_lead' | translate }}
    </span>
    <div class="flex items-center gap-1">
      <button
        type="button"
        class="grid h-6 w-6 shrink-0 place-items-center rounded text-gray-400 hover:bg-gray-100"
        (click)="settingsClick.emit()"
      >
        <app-icon class="!text-[16px] !leading-none !h-4 !w-4">settings</app-icon>
      </button>
      <button
        type="button"
        class="grid h-6 w-6 shrink-0 place-items-center rounded text-gray-400 hover:bg-gray-100"
        (click)="close()"
      >
        <app-icon class="!text-[16px] !leading-none !h-4 !w-4">close</app-icon>
      </button>
    </div>
  </div>

  <div
    [class]="compact
      ? 'flex min-w-0 flex-col gap-2 px-3 py-2.5'
      : 'flex min-w-0 flex-col gap-2 px-3 py-2.5'"
  >

    <app-input
      [class]="compact
        ? 'block min-w-0 [&_.p-inputtext]:!h-9 [&_.p-inputtext]:!px-3 [&_.p-inputtext]:!text-sm'
        : 'block min-w-0 [&_.p-inputtext]:!h-9 [&_.p-inputtext]:!px-3 [&_.p-inputtext]:!text-sm'"
      formControlName="name"
      [formControl]="$any(form.get('name'))"
      [size]="controlSize"
      placeholder="{{ 'name' | translate }}"
    />

    @if (has('price')) {
      <div
        [class]="compact
          ? 'grid min-w-0 grid-cols-[minmax(0,1fr)_104px] items-center gap-2'
          : 'grid min-w-0 grid-cols-[minmax(0,1fr)_104px] items-center gap-2'"
      >
        <app-input
          [class]="compact
            ? 'block min-w-0 [&_.p-inputnumber]:!w-full [&_.p-inputtext]:!h-9 [&_.p-inputtext]:!w-full [&_.p-inputtext]:!px-3 [&_.p-inputtext]:!text-sm'
            : 'block min-w-0 [&_.p-inputnumber]:!w-full [&_.p-inputtext]:!h-9 [&_.p-inputtext]:!w-full [&_.p-inputtext]:!px-3 [&_.p-inputtext]:!text-sm'"
          formControlName="price"
          [formControl]="$any(form.get('price'))"
          [inputType]="'number'"
          [showErrors]="false"
          [size]="controlSize"
          placeholder="{{ 'price' | translate }}"
        />
        <app-select
          [class]="compact
            ? 'block w-[104px] min-w-0 shrink-0 self-center [&_.p-select]:!h-9 [&_.p-select]:!min-w-0 [&_.p-select-label]:!px-3 [&_.p-select-label]:!py-1.5 [&_.p-select-label]:!text-sm [&_.p-select-dropdown]:!w-8'
            : 'block w-[104px] min-w-0 shrink-0 self-center [&_.p-select]:!h-9 [&_.p-select]:!min-w-0 [&_.p-select-label]:!px-3 [&_.p-select-label]:!py-1.5 [&_.p-select-label]:!text-sm [&_.p-select-dropdown]:!w-8'"
          formControlName="currency"
          [options]="currencyOptions"
          optionLabel="label"
          optionValue="value"
          [fluid]="false"
          [size]="controlSize"
          [appendTo]="'body'"
        />
      </div>
    }

    @if (has('phones')) {
      <div class="flex flex-col gap-1.5">
        <span class="text-xs text-gray-400">{{ 'phone' | translate }}</span>
        <div formArrayName="phones" class="flex flex-col gap-1.5">
          @for (ctrl of phones.controls; track $index) {
            <div class="flex min-w-0 items-center gap-2">
              <app-input
                [class]="compact
                  ? 'block min-w-0 flex-1 [&_.p-inputtext]:!h-9 [&_.p-inputtext]:!px-3 [&_.p-inputtext]:!text-sm'
                  : 'block min-w-0 flex-1 [&_.p-inputtext]:!h-9 [&_.p-inputtext]:!px-3 [&_.p-inputtext]:!text-sm'"
                [formControl]="ctrl"
                [size]="controlSize"
                placeholder="+380..."
              />
              @if (phones.length > 1) {
                <button
                  type="button"
                  class="grid h-6 w-6 shrink-0 place-items-center rounded text-gray-400 hover:bg-gray-100 hover:text-red-400"
                  (click)="removePhone($index)"
                >
                  <app-icon class="!text-[16px] !leading-none !h-4 !w-4">close</app-icon>
                </button>
              }
            </div>
          }
        </div>
        <button
          type="button"
          class="flex items-center gap-1 self-start text-xs text-blue-500 hover:text-blue-600"
          (click)="addPhone()"
        >
          <app-icon class="!text-[14px] !h-[14px] !w-[14px] !leading-none">add</app-icon>
          {{ 'add_phone' | translate }}
        </button>
      </div>
    }

    @if (has('emails')) {
      <div class="flex flex-col gap-1.5">
        <span class="text-xs text-gray-400">{{ 'email' | translate }}</span>
        <div formArrayName="emails" class="flex flex-col gap-1.5">
          @for (ctrl of emails.controls; track $index) {
            <div class="flex min-w-0 items-center gap-2">
              <app-input
                [class]="compact
                  ? 'block min-w-0 flex-1 [&_.p-inputtext]:!h-9 [&_.p-inputtext]:!px-3 [&_.p-inputtext]:!text-sm'
                  : 'block min-w-0 flex-1 [&_.p-inputtext]:!h-9 [&_.p-inputtext]:!px-3 [&_.p-inputtext]:!text-sm'"
                [formControl]="ctrl"
                [size]="controlSize"
                placeholder="email@..."
              />
              @if (emails.length > 1) {
                <button
                  type="button"
                  class="grid h-6 w-6 shrink-0 place-items-center rounded text-gray-400 hover:bg-gray-100 hover:text-red-400"
                  (click)="removeEmail($index)"
                >
                  <app-icon class="!text-[16px] !leading-none !h-4 !w-4">close</app-icon>
                </button>
              }
            </div>
          }
        </div>
        <button
          type="button"
          class="flex items-center gap-1 self-start text-xs text-blue-500 hover:text-blue-600"
          (click)="addEmail()"
        >
          <app-icon class="!text-[14px] !h-[14px] !w-[14px] !leading-none">add</app-icon>
          {{ 'add_email' | translate }}
        </button>
      </div>
    }

    @if (has('addresses')) {
      <div class="flex flex-col gap-1.5">
        <span class="text-xs text-gray-400">{{ 'addresses' | translate }}</span>
        <app-board-v3-address-editor formControlName="addresses" size="small" />
      </div>
    }

    @if (has('assigned_id')) {
      <div class="flex flex-col gap-1">
        <span class="text-xs text-gray-400">{{ 'assigned' | translate }}</span>
        <app-select
          [class]="compact
            ? 'block min-w-0 [&_.p-select]:!h-9 [&_.p-select]:!min-w-0 [&_.p-select-label]:!px-3 [&_.p-select-label]:!py-1.5 [&_.p-select-label]:!text-sm [&_.p-select-dropdown]:!w-8'
            : 'block min-w-0 [&_.p-select]:!h-9 [&_.p-select]:!min-w-0 [&_.p-select-label]:!px-3 [&_.p-select-label]:!py-1.5 [&_.p-select-label]:!text-sm [&_.p-select-dropdown]:!w-8'"
          formControlName="assigned_id"
          [options]="managersOptions"
          optionLabel="name"
          optionValue="id"
          [isAvatar]="true"
          [showClear]="true"
          [size]="controlSize"
          [appendTo]="'body'"
        />
      </div>
    }

    @if (has(clientsKey)) {
      <div class="flex flex-col gap-1.5">
        <span class="text-xs text-gray-400">{{ 'contact' | translate }}</span>
        @for (slot of contactSlots; track $index; let i = $index) {
          <app-board-v3-contact-picker
            [slot]="slot"
            [excludeIds]="pickedContactIds"
            [removable]="contactSlots.length > 1"
            (slotChange)="setContactSlot(i, $event)"
            (remove)="removeContactSlot(i)"
          />
        }
        <button
          type="button"
          class="flex items-center gap-1 self-start text-xs text-blue-500 hover:text-blue-600"
          (click)="addContactSlot()"
        >
          <app-icon class="!text-[14px] !h-[14px] !w-[14px] !leading-none">add</app-icon>
          {{ 'board_v3_contact_add_participant' | translate }}
        </button>
      </div>
      <div class="flex flex-col gap-1.5">
        <span class="text-xs text-gray-400">{{ 'company' | translate }}</span>
        <app-board-v3-company-picker [slot]="companySlot" (slotChange)="companySlot = $event" />
      </div>
    }

    @for (field of customFieldDefs; track fieldKey(field); let i = $index) {
      <app-custom-field-control
        [class]="compact
          ? 'block min-w-0 [&_.p-select]:!h-9 [&_.p-select]:!min-w-0 [&_.p-select-label]:!px-3 [&_.p-select-label]:!py-1.5 [&_.p-select-label]:!text-sm [&_.p-select-dropdown]:!w-8 [&_input]:!h-9 [&_input]:!px-3 [&_input]:!text-sm [&_textarea]:!text-sm'
          : 'block min-w-0 [&_.p-select]:!h-9 [&_.p-select]:!min-w-0 [&_.p-select-label]:!px-3 [&_.p-select-label]:!py-1.5 [&_.p-select-label]:!text-sm [&_.p-select-dropdown]:!w-8 [&_input]:!h-9 [&_input]:!px-3 [&_input]:!text-sm [&_textarea]:!text-sm'"
        [field]="field"
        [control]="customControls[i]"
        [dateTimeControl]="getDateTimeControl(i)"
        appearance="quick"
      />
    }

  </div>

  <div
    [class]="compact
      ? 'flex min-w-0 gap-2 border-t border-gray-100 px-3 py-2.5'
      : 'flex min-w-0 gap-2 border-t border-gray-100 px-3 py-2.5'"
  >
    <app-button
      [btnType]="'stroked'"
      [customClass]="compact
        ? 'w-full whitespace-nowrap !h-8 !min-w-0 !rounded-md !px-2 !text-sm'
        : 'w-full whitespace-nowrap !h-9 !min-w-0 !rounded-md !px-2 !text-sm'"
      class="min-w-0 flex-1"
      (onChangeClick)="close()"
    >
      {{ 'cancel' | translate }}
    </app-button>
    <app-button
      [customClass]="compact
        ? 'w-full whitespace-nowrap !h-8 !min-w-0 !rounded-md !px-2 !text-sm'
        : 'w-full whitespace-nowrap !h-9 !min-w-0 !rounded-md !px-2 !text-sm'"
      class="min-w-0 flex-1"
      [loading]="loading"
      (onChangeClick)="submit()"
    >
      {{ 'create' | translate }}
    </app-button>
  </div>

</div>
